/**
 * User: daletan
 * Date: 9/28/15
 * Time: 9:51 AM
 * Copyright 1stdibs.com, Inc. 2015. All Rights Reserved.
 */

'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const styles = require('./Measurement-style.scss');
const ContextComponent = require('../../../global/components/ContextComponent');

class Measurement extends ContextComponent {
    render() {
        const values = this.props.values;
        const numValues = values.length;

        if (!numValues || !Array.isArray(values)) {
            return null;
        }

        return (
            <span>
                {values.map((measurement, index) => {
                    let value = measurement.displayValue;
                    let unitEl;

                    if (!value) {
                        value = measurement.value;
                        unitEl = <span className={styles.unit}> {measurement.unit}</span>;
                    }
                    return (
                        <span className={styles.measurement} key={index}>
                            <span className={styles.value}>{value}</span>
                            {unitEl}
                            <span className={styles.unitLabel}>{measurement.unitLabel}</span>
                            {index < numValues - 1 ? <span className={styles.divider}>x</span> : ''}
                        </span>
                    );
                })}
            </span>
        );
    }
}

Measurement.propTypes = {
    values: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
            unit: PropTypes.string.isRequired,
            unitLabel: PropTypes.string.isRequired,
            schemaType: PropTypes.string.isRequired,
        })
    ).isRequired,
};

module.exports = Measurement;



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/Measurement/Measurement-view.jsx